export default "__VITE_ASSET__5CxlB5YU__"